'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = entities;

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _ArrayModels = require('@vezeeta/enterprise-utils/lib/ArrayModels');

var _webSso = require('@vezeeta/web-sso');

var _entities = require('../types/entities');

var _entities2 = require('../actions/entities');

var _language = require('../types/language');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getBranchInsurances),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(setBranchInsurances),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(setBranchInsurancesSuccess),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(resetBranchInsurances),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(getEntitiesByEntityKeys),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(getBranchesByBranchKeys),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(getUsersByKeys),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(getUsersBranches),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(upsertEntity),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(upsertBranch),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(upsertUser),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(getHomeVisitsDrStats),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(loadHomeVisitsDrLiveStatus),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(entities);

// get default insurance companies assigned on a branch
function getBranchInsurances(payload) {
  var accountKey, branchInsurances, branchInsurancesResponse;
  return _regenerator2.default.wrap(function getBranchInsurances$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          accountKey = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name;
          branchInsurances = new _webUtils.API();
          _context.next = 4;
          return branchInsurances.get(_webUtils.Urls.entity.GetBranchInsurances + '?branchKey=' + payload.branchKey, [{
            key: 'AccountKey',
            value: accountKey
          }]);

        case 4:
          branchInsurancesResponse = _context.sent;

          if (!_webUtils.STATUS.isSuccess(branchInsurancesResponse.status)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.BRANCHES.FETCH_BRANCH_INSURANCES.SUCCESS,
            branchInsurances: branchInsurancesResponse.data
          });

        case 8:
          _context.next = 12;
          break;

        case 10:
          _context.next = 12;
          return (0, _effects.put)({ type: _entities2.ENTITIES.BRANCHES.FETCH_BRANCH_INSURANCES.FAIL });

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
// set updates and changes on insurance companies assigned on a branch
function setBranchInsurances(payload) {
  var accountToken, branchInsurances, branchInsurancesBody, branchInsurancesHeaders, branchInsurancesResponse;
  return _regenerator2.default.wrap(function setBranchInsurances$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          // payload.branchKey payload.insurances
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          branchInsurances = new _webUtils.API();
          branchInsurancesBody = {
            BranchKey: payload.branchKey,
            InsuranceProviderKeys: payload.insurances
          };
          branchInsurancesHeaders = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }];
          _context2.next = 6;
          return branchInsurances.post('' + _webUtils.Urls.entity.UpsertBranchInsurances, branchInsurancesBody, branchInsurancesHeaders);

        case 6:
          branchInsurancesResponse = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(branchInsurancesResponse.status)) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.BRANCHES.SET_BRANCH_INSURANCES.SUCCESS,
            payload: payload.branchKey
          });

        case 10:
          _context2.next = 14;
          break;

        case 12:
          _context2.next = 14;
          return (0, _effects.put)({ type: _entities2.ENTITIES.BRANCHES.SET_BRANCH_INSURANCES.FAIL });

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function setBranchInsurancesSuccess(_ref) {
  var payload = _ref.payload;
  return _regenerator2.default.wrap(function setBranchInsurancesSuccess$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.BRANCHES.FETCH_BRANCH_INSURANCES.LOAD,
            branchKey: payload
          });

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function resetBranchInsurances() {
  return _regenerator2.default.wrap(function resetBranchInsurances$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.BRANCHES.FETCH_BRANCH_INSURANCES.RESET_DONE
          });

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function getEntitiesByEntityKeys(payload /*: { entitiesKeys: Array<string> }*/) {
  var _this = this;

  var entitiesResponse, incomingEntities;
  return _regenerator2.default.wrap(function getEntitiesByEntityKeys$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return new _webSso.AuthApi().post(_webUtils.Urls.profile, {
            query: 'query entityQuery ($entityKeys : [String])\n        {\n          entitiesByKeys(entityKeys:$entityKeys)\n          {\n            entityKey\n            prefixTitleId\n            entityPhotos\n            {\n              url\n              photoTypeId\n            }\n            entityCountryDetails\n            {\n              name\n              languageId\n              about\n            }\n            branches\n            {\n              branchKey\n              branchLanguageDetails\n              {\n                name\n                languageId\n              }\n            }\n          }\n        }',
            variables: {
              entityKeys: payload.entityKeys
            }
          });

        case 2:
          entitiesResponse = _context7.sent;

          if (!_webUtils.STATUS.isSuccess(entitiesResponse.status)) {
            _context7.next = 11;
            break;
          }

          _context7.next = 6;
          return Promise.all(entitiesResponse.data.entitiesByKeys.map(function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(entity) {
              var entityPhotos;
              return _regenerator2.default.wrap(function _callee2$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      entityPhotos = [];

                      // Looping through all photos

                      if (!entity.entityPhotos) {
                        _context6.next = 4;
                        break;
                      }

                      _context6.next = 4;
                      return Promise.all(entity.entityPhotos.map(function () {
                        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(photo) {
                          var base64;
                          return _regenerator2.default.wrap(function _callee$(_context5) {
                            while (1) {
                              switch (_context5.prev = _context5.next) {
                                case 0:
                                  _context5.next = 2;
                                  return (0, _ArrayModels.convertURLtoBase64)([photo.url]);

                                case 2:
                                  base64 = _context5.sent;

                                  entityPhotos.push(_extends({
                                    base64: base64.pop()
                                  }, photo));

                                case 4:
                                case 'end':
                                  return _context5.stop();
                              }
                            }
                          }, _callee, _this);
                        }));

                        return function (_x2) {
                          return _ref3.apply(this, arguments);
                        };
                      }()));

                    case 4:
                      return _context6.abrupt('return', _extends({}, entity, {
                        entityPhotos: entityPhotos
                      }));

                    case 5:
                    case 'end':
                      return _context6.stop();
                  }
                }
              }, _callee2, _this);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }()));

        case 6:
          incomingEntities = _context7.sent;
          _context7.next = 9;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.ENTITIES.FETCH.SUCCEEDED,
            entities: incomingEntities
          });

        case 9:
          _context7.next = 13;
          break;

        case 11:
          _context7.next = 13;
          return (0, _effects.put)({ type: _entities2.ENTITIES.ENTITIES.FETCH.FAILED, error: entitiesResponse });

        case 13:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked5, this);
}

function getBranchesByBranchKeys(payload /*: { branchKeys: Array<string>, statusIdOnly: boolean }*/) {
  var branchKeys, statusIdOnly, branchQuery, branchesResponse;
  return _regenerator2.default.wrap(function getBranchesByBranchKeys$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          branchKeys = payload.branchKeys, statusIdOnly = payload.statusIdOnly;
          branchQuery = void 0;


          if (statusIdOnly) {
            branchQuery = '\n      branchKey\n      statusId\n      branchLanguageDetails\n      {\n        name    \n      }\n    ';
          } else {
            branchQuery = '\n      branchKey\n      latitude\n      longitude\n      clinicNumberIsoCode\n      statusId\n      branchAdminMobileNumber\n      branchAdminMobileNumberIsoCode\n      branchLanguageDetails\n      {\n        languageId\n        name\n        floor\n        landMark\n        streetName\n        apartmentNumber\n        buildingNumber\n      }\n      branchPhones\n      {\n        number\n        phoneTypeId\n        countryCode\n      }\n      rooms {\n        roomKey\n        userRooms {\n          statusId \n          user {\n            userKey\n          }\n        }\n      }\n    ';
          }

          _context8.next = 5;
          return new _webSso.AuthApi().post(_webUtils.Urls.profile, {
            query: 'query branchesQuery($branchKeys: [String]!)\n      {\n        branchesByKeys(branchKeys: $branchKeys)\n        {\n          ' + branchQuery + '\n        }\n      }',
            variables: {
              branchKeys: branchKeys
            }
          });

        case 5:
          branchesResponse = _context8.sent;

          if (!_webUtils.STATUS.isSuccess(branchesResponse.status)) {
            _context8.next = 11;
            break;
          }

          _context8.next = 9;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.BRANCHES.FETCH.SUCCEEDED,
            branches: branchesResponse.data.branchesByKeys,
            isFullyLoaded: !statusIdOnly
          });

        case 9:
          _context8.next = 13;
          break;

        case 11:
          _context8.next = 13;
          return (0, _effects.put)({ type: _entities2.ENTITIES.BRANCHES.FETCH.FAILED, error: branchesResponse });

        case 13:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked6, this);
}

function getUsersByKeys(payload /*: { users: Map<string, Array<string>>, branchKey: string }*/) {
  var accountsKeys, accountToken, headers, _ref4, accountsResponse, profileResponse;

  return _regenerator2.default.wrap(function getUsersByKeys$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!(payload.users.size === 0)) {
            _context9.next = 4;
            break;
          }

          _context9.next = 3;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.USERS.FETCH.SUCCEEDED,
            profiles: [],
            accounts: [],
            userRooms: []
          });

        case 3:
          return _context9.abrupt('return');

        case 4:
          accountsKeys = Array.from(payload.users.keys());
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          headers = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }];
          _context9.next = 9;
          return (0, _effects.all)({
            accountsResponse: new _webUtils.API().post(_webUtils.Urls.getAccountsByKeys, {
              AccountKeys: accountsKeys
            }, headers),
            profileResponse: new _webSso.AuthApi().post(_webUtils.Urls.profile, {
              query: 'query usersQuery($userKeys: [String]!)\n        {\n          usersByKeys(userKeys: $userKeys)\n          {\n            userKey\n            userSpecialties {\n              isMainSpecialty\n              specialtyKey\n            }\n            nationalitiesIds\n            userPhotos {\n              photoTypeId\n              url\n            }\n            prefixTitleId\n            titleId\n            genderId\n            userCountryDetails {\n              firstName\n              lastName\n              languageId\n              about\n              professionalTitle\n            }\n            statusId\n          }\n        }',
              variables: {
                userKeys: accountsKeys
              }
            })
          });

        case 9:
          _ref4 = _context9.sent;
          accountsResponse = _ref4.accountsResponse;
          profileResponse = _ref4.profileResponse;

          if (!(_webUtils.STATUS.isSuccess(accountsResponse.status) && _webUtils.STATUS.isSuccess(profileResponse.status))) {
            _context9.next = 17;
            break;
          }

          _context9.next = 15;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.USERS.FETCH.SUCCEEDED,
            profiles: profileResponse.data.usersByKeys,
            accounts: accountsResponse.data,
            userRooms: payload.users,
            branchKey: payload.branchKey
          });

        case 15:
          _context9.next = 19;
          break;

        case 17:
          _context9.next = 19;
          return (0, _effects.put)({ type: _entities2.ENTITIES.USERS.FETCH.FAILED });

        case 19:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked7, this);
}

function getUsersBranches(payload /*: { users: Array<string> }*/) {
  var accountsKeys, profileResponse;
  return _regenerator2.default.wrap(function getUsersBranches$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          if (!(payload.users.size === 0)) {
            _context10.next = 4;
            break;
          }

          _context10.next = 3;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.USERS.FETCH.SUCCEEDED,
            users: []
          });

        case 3:
          return _context10.abrupt('return');

        case 4:
          accountsKeys = payload.users;
          _context10.next = 7;
          return new _webSso.AuthApi().post(_webUtils.Urls.profile, {
            query: 'query usersQuery($userKeys: [String]!)\n        {\n          usersByKeys(userKeys: $userKeys)\n          {\n            userKey\n            entities {\n              branches {\n                userBranches {\n                  userKey\n                  branchKey\n                  fees\n                  userBranchesInsuranceProviders{\n                    insuranceProviderKey\n                  }\n                }\n              }\n            }\n          }\n        }',
            variables: {
              userKeys: accountsKeys
            }
          });

        case 7:
          profileResponse = _context10.sent;

          if (!_webUtils.STATUS.isSuccess(profileResponse.status)) {
            _context10.next = 13;
            break;
          }

          _context10.next = 11;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.USERS.FETCH_BRANCHES.SUCCEEDED,
            users: profileResponse.data.usersByKeys
          });

        case 11:
          _context10.next = 15;
          break;

        case 13:
          _context10.next = 15;
          return (0, _effects.put)({ type: _entities2.ENTITIES.USERS.FETCH_BRANCHES.FAILED });

        case 15:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked8, this);
}

function upsertEntity(payload /*: {
                                entity: {
                                  entityKey: string,
                                  prefixTitleId: string,
                                  countryId: string,
                                  name: Map<number, string>,
                                  about: Map<number, string>,
                                  photos: Map<number, string>,
                                },
                              }*/) {
  var _payload$entity, entityKey, prefixTitleId, countryId, name, about, photos, accountToken, entityCountryDetails, entityPhotos, upsertEntityHeaders, _ref5, accountsApi, profileApi;

  return _regenerator2.default.wrap(function upsertEntity$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _payload$entity = payload.entity, entityKey = _payload$entity.entityKey, prefixTitleId = _payload$entity.prefixTitleId, countryId = _payload$entity.countryId, name = _payload$entity.name, about = _payload$entity.about, photos = _payload$entity.photos;
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          entityCountryDetails = (0, _ArrayModels.generateArrayModelsFromMaps)({ name: name, about: about, countryId: countryId }, 'languageId');
          entityPhotos = (0, _ArrayModels.generateArrayModelsFromMaps)({ photoBase64: photos }, 'photoTypeId');
          upsertEntityHeaders = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }, {
            key: 'EntityKey',
            value: entityKey
          }];
          _context11.next = 7;
          return (0, _effects.all)({
            accountsApi: new _webUtils.API().post(_webUtils.Urls.entity.createEntity, {
              NameEnglish: name.get(_entities.LANGUAGE.ENGLISH),
              NameArabic: name.get(_entities.LANGUAGE.ARABIC),
              EntityTypeId: 1,
              PrefixTitleId: prefixTitleId,
              EntityKey: entityKey,
              ImageModel: {
                ImageBase64String: photos.get(_entities.PHOTO_TYPE.LOGO)
              }
            }, upsertEntityHeaders),
            profileApi: new _webSso.AuthApi().post(_webUtils.Urls.profile, {
              query: 'mutation ProfileMutation ($entityInput : EntityInput!)\n        {\n          upsertEntity(entityInput: $entityInput) {\n            entityKey\n          }\n        }',
              variables: {
                entityInput: {
                  entityKey: entityKey,
                  prefixTitleId: prefixTitleId,
                  entityCountryDetails: entityCountryDetails,
                  entityPhotos: entityPhotos
                }
              }
            })
          });

        case 7:
          _ref5 = _context11.sent;
          accountsApi = _ref5.accountsApi;
          profileApi = _ref5.profileApi;

          if (!(_webUtils.STATUS.isSuccess(accountsApi.status) && _webUtils.STATUS.isSuccess(profileApi.status))) {
            _context11.next = 15;
            break;
          }

          _context11.next = 13;
          return (0, _effects.put)({ type: _entities2.ENTITIES.ENTITIES.EDIT.SUCCEEDED, entity: payload.entity, entityKey: entityKey });

        case 13:
          _context11.next = 17;
          break;

        case 15:
          _context11.next = 17;
          return (0, _effects.put)({ type: _entities2.ENTITIES.ENTITIES.EDIT.FAILED });

        case 17:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked9, this);
}

function upsertBranch(payload /*: {
                                branch: {
                                  branchKey: string,
                                  lat: number,
                                  lng: number,
                                  isoCode: string,
                                  name: Map<string, string>,
                                  phones: Map<number, Object>,
                                  adminPhone: Map<number, Object>,
                                  buildingNumber: Map<number, string>,
                                  floor: Map<number, string>,
                                  landMark: Map<number, string>,
                                  apartmentNumber: Map<number, string>,
                                },
                              }*/) {
  var _payload$branch, branchKey, lat, lng, isoCode, name, phones, adminPhone, buildingNumber, zipCode, floor, landMark, apartmentNumber, entityKey, streetName, branchLanguageDetails, accountToken, upsertEntityHeaders, _ref6, accountsApi, profileApi;

  return _regenerator2.default.wrap(function upsertBranch$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _payload$branch = payload.branch, branchKey = _payload$branch.branchKey, lat = _payload$branch.lat, lng = _payload$branch.lng, isoCode = _payload$branch.isoCode, name = _payload$branch.name, phones = _payload$branch.phones, adminPhone = _payload$branch.adminPhone, buildingNumber = _payload$branch.buildingNumber, zipCode = _payload$branch.zipCode, floor = _payload$branch.floor, landMark = _payload$branch.landMark, apartmentNumber = _payload$branch.apartmentNumber, entityKey = _payload$branch.entityKey, streetName = _payload$branch.streetName;
          branchLanguageDetails = (0, _ArrayModels.generateArrayModelsFromMaps)({ buildingNumber: buildingNumber, floor: floor, landMark: landMark, apartmentNumber: apartmentNumber, streetName: streetName, name: name }, 'languageId');
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          upsertEntityHeaders = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }, {
            key: 'EntityKey',
            value: entityKey
          }];
          _context12.next = 6;
          return (0, _effects.all)({
            accountsApi: new _webUtils.API().post(_webUtils.Urls.entity.createEntity, {
              NameEnglish: name.get(_entities.LANGUAGE.ENGLISH),
              NameArabic: name.get(_entities.LANGUAGE.ARABIC),
              EntityTypeId: 2,
              EntityKey: branchKey,
              ImageModel: {
                ImageBase64String: ''
              }
            }, upsertEntityHeaders),
            profileApi: new _webSso.AuthApi().post(_webUtils.Urls.profile, {
              query: 'mutation ProfileMutation($branchInput : BranchInput!)\n      {\n        upsertBranch(branchInput: $branchInput){\n          branchKey\n          branchLanguageDetails\n          {\n            name\n          }\n        }\n      }',
              variables: {
                branchInput: {
                  branchKey: branchKey,
                  entityKey: entityKey,
                  latitude: lat,
                  longitude: lng,
                  branchLanguageDetails: branchLanguageDetails,
                  clinicNumberIsoCode: isoCode,
                  branchPhones: phones,
                  statusId: _entities.STATUS.ACTIVE,
                  branchAdminMobileNumber: adminPhone && adminPhone[0] && adminPhone[0].adminNumber,
                  branchAdminMobileNumberIsoCode: isoCode,
                  zipCode: zipCode
                }
              }
            })
          });

        case 6:
          _ref6 = _context12.sent;
          accountsApi = _ref6.accountsApi;
          profileApi = _ref6.profileApi;

          if (!(_webUtils.STATUS.isSuccess(profileApi.status) && _webUtils.STATUS.isSuccess(accountsApi.status))) {
            _context12.next = 14;
            break;
          }

          _context12.next = 12;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.BRANCHES.EDIT.SUCCEEDED,
            branch: payload.branch,
            branchKey: branchKey,
            entityKey: entityKey
          });

        case 12:
          _context12.next = 16;
          break;

        case 14:
          _context12.next = 16;
          return (0, _effects.put)({ type: _entities2.ENTITIES.BRANCHES.EDIT.FAILED });

        case 16:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked10, this);
}

/*:: type Branch = {
  branchKey: string,
  branchRooms: Array<string>,
  branchInsurances: Array<string>,
  branchFees: number,
};*/


function upsertUser(payload /*: {
                              entitiesKeys: Array<string>,
                              userDetails: {
                                photos: Map<number, string>,
                                firstName: Map<string, string>,
                                lastName: Map<string, string>,
                                countryCode: string,
                                isoCode: string,
                                number: string,
                                NationalitiesIds: Array<number>,
                                email: string,
                                birthDate: string,
                                gender: number,
                                mainSpecialty: string,
                                specialtyGroupId: string,
                                subSpecialties: Array<string>,
                                prefixTitle: string,
                                professionalTitle: string,
                                fullProfessionalTitle: Map<string, string>,
                                about: Map<string, string>,
                                branches: Array<Branch>,
                                specialtyGroupId: string,
                                countryId: string,
                                statusId: number,
                              },
                            }*/) {
  var userDetails, entitiesKeys, key, gender, prefixTitle, firstName, lastName, NationalitiesIds, professionalTitle, about, photos, countryId, title, subSpecialties, mainSpecialty, branches, number, countryCodeId, email, specialtyGroupId, statusId, userKey, accountToken, accountsUrl, accountsHeader, imgEdited, profilePhoto, isDataUrlRegex, isUserEdit, userData, getPayload, accountsResponse, userCountryDetails, userPhotos, userSpecialties, userBranchInput, profileResponse;
  return _regenerator2.default.wrap(function upsertUser$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          userDetails = payload.userDetails, entitiesKeys = payload.entitiesKeys;
          key = userDetails.key, gender = userDetails.gender, prefixTitle = userDetails.prefixTitle, firstName = userDetails.firstName, lastName = userDetails.lastName, NationalitiesIds = userDetails.NationalitiesIds, professionalTitle = userDetails.professionalTitle, about = userDetails.about, photos = userDetails.photos, countryId = userDetails.countryId, title = userDetails.title, subSpecialties = userDetails.subSpecialties, mainSpecialty = userDetails.mainSpecialty, branches = userDetails.branches, number = userDetails.number, countryCodeId = userDetails.countryCodeId, email = userDetails.email, specialtyGroupId = userDetails.specialtyGroupId, statusId = userDetails.statusId;

          // Check if there AccountKey saved in the cookies

          userKey = _webUtils.Cookie.get(_webUtils.Cookie.ACCOUNT_KEY);
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          accountsUrl = void 0;
          accountsHeader = [];

          // We first check is the account was created in Accounts API or not
          // If it's already created we call EditAccount, and pass AccountKey in the headers
          // If not we call RegisterAccount

          imgEdited = false;

          accountsHeader.push({
            key: 'x-vzt-authentication',
            value: accountToken
          });
          profilePhoto = photos.get(_entities.PHOTO_TYPE.PROFILE_PICTURE);
          isDataUrlRegex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i; // eslint-disable-line

          isUserEdit = false;

          if (userKey) {
            isUserEdit = true;
            imgEdited = profilePhoto.match(isDataUrlRegex);
            if (key !== undefined && key !== null && !imgEdited) {
              profilePhoto = {};
            } else {
              profilePhoto = {
                ImageBase64String: profilePhoto
              };
            }
            accountsUrl = _webUtils.Urls.account.editAccount;
          } else {
            profilePhoto = {
              ImageBase64String: profilePhoto
            };
            accountsUrl = _webUtils.Urls.account.registerAccount;
          }

          userData = {
            FirstName: firstName.get(_entities.LANGUAGE.ENGLISH),
            LastName: lastName.get(_entities.LANGUAGE.ENGLISH),
            FirstNameArabic: firstName.get(_entities.LANGUAGE.ARABIC),
            LastNameArabic: lastName.get(_entities.LANGUAGE.ARABIC),
            PhoneNumber: number,
            EmailAddress: email,
            CountryId: countryId,
            CountryCodeId: countryCodeId,
            SpecialityKey: mainSpecialty,
            ImageModel: profilePhoto
          };

          getPayload = function getPayload() {
            if (isUserEdit) return _extends({}, userData, { AccountKey: (0, _webUtils.decrypt)(userKey) });
            return _extends({}, userData, { LoginStatus: 'Pending' });
          };

          _context13.next = 16;
          return new _webUtils.API().post(accountsUrl, getPayload(), accountsHeader);

        case 16:
          accountsResponse = _context13.sent;

          if (!_webUtils.STATUS.isSuccess(accountsResponse.status)) {
            _context13.next = 38;
            break;
          }

          userKey = accountsResponse.data.AccountKey;

          // Save AccountKey in Cookies to know if the account has been generated before or not
          _webUtils.Cookie.set(_webUtils.Cookie.ACCOUNT_KEY, (0, _webUtils.encrypt)(userKey));

          // Create userCountryDetails array
          userCountryDetails = (0, _ArrayModels.generateArrayModelsFromMaps)({
            firstName: firstName,
            lastName: lastName,
            professionalTitle: professionalTitle,
            about: about,
            countryId: countryId
          }, 'languageId');

          // Create userPhotos array

          userPhotos = (0, _ArrayModels.generateArrayModelsFromMaps)({ photoBase64: photos, statusId: statusId }, 'photoTypeId');

          // Create userSpecialties array

          userSpecialties = subSpecialties.map(function (subSpecialty) {
            return {
              specialtyKey: subSpecialty,
              statusId: statusId,
              isMainSpecialty: false
            };
          });


          userSpecialties = [].concat(userSpecialties, [{
            specialityGroupId: specialtyGroupId,
            specialtyKey: mainSpecialty,
            statusId: statusId,
            isMainSpecialty: true
          }]);
          // Create userBranchInput
          userBranchInput = branches.map(function (branch /*: Branch*/) {
            var branchKey = branch.branchKey,
                branchFees = branch.branchFees,
                branchInsurances = branch.branchInsurances,
                bookingTypeId = branch.bookingTypeId;

            var userBranchesInsuranceProviders = branchInsurances.map(function (branchInsurance) {
              return {
                insuranceProviderKey: branchInsurance
              };
            });

            return {
              userKey: userKey,
              branchKey: branchKey,
              fees: branchFees,
              userBranchesInsuranceProviders: userBranchesInsuranceProviders,
              isOutsourced: false,
              isGhostProfile: false,
              acceptPromoCodes: false,
              supportWaitingList: false,
              bookingTypeId: bookingTypeId
            };
          });
          _context13.next = 27;
          return (0, _effects.all)({
            profileResponse: new _webSso.AuthApi().post(_webUtils.Urls.profile, {
              query: 'mutation ProfileMutation($userInput: UserInput!, $userBranchInput: [UserBranchInput])\n          {\n            upsertUser(userInput: $userInput, userBranchInput: $userBranchInput) {\n              userKey\n            }\n          }\n        ',
              variables: {
                userInput: {
                  userKey: userKey,
                  nationalitiesIds: NationalitiesIds,
                  genderId: gender,
                  titleId: title,
                  prefixTitleId: prefixTitle,
                  senderName: 'Vezeeta.com',
                  statusId: statusId,
                  entityKeys: entitiesKeys,
                  userCountryDetails: userCountryDetails,
                  userSpecialties: userSpecialties,
                  userPhotos: userPhotos
                },
                userBranchInput: userBranchInput
              }
            })
          });

        case 27:
          profileResponse = _context13.sent;

          if (!_webUtils.STATUS.isSuccess(profileResponse.profileResponse.status)) {
            _context13.next = 34;
            break;
          }

          // Remove AccountKey cookie since we don't need it anymore
          _webUtils.Cookie.remove(_webUtils.Cookie.ACCOUNT_KEY);

          _context13.next = 32;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.USERS.ADD.SUCCEEDED,
            user: userDetails,
            userKey: userKey,
            isUserEdit: isUserEdit
          });

        case 32:
          _context13.next = 36;
          break;

        case 34:
          _context13.next = 36;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.USERS.ADD.FAILED,
            error: accountsResponse.response.Message,
            isConflict: false
          });

        case 36:
          _context13.next = 40;
          break;

        case 38:
          _context13.next = 40;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.USERS.ADD.FAILED,
            error: accountsResponse.response.Message,
            isConflict: _webUtils.STATUS.isConflict(accountsResponse.status)
          });

        case 40:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked11, this);
}

function getHomeVisitsDrStats(payload) {
  var homeVisitsDrStats, homeVisitsDrStatsResponse;
  return _regenerator2.default.wrap(function getHomeVisitsDrStats$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          homeVisitsDrStats = new _webUtils.API();
          _context14.next = 3;
          return homeVisitsDrStats.get(_webUtils.Urls.homeVisits.getDoctorStats + '?SupplierAccountKey=' + payload.SupplierKey + '&SupplierBranchKey=' + payload.BranchKey + '&CountryId=' + payload.CountryId + '&FilterStatsByDate=' + payload.FilterStatsByDate);

        case 3:
          homeVisitsDrStatsResponse = _context14.sent;

          if (!_webUtils.STATUS.isSuccess(homeVisitsDrStatsResponse.status)) {
            _context14.next = 9;
            break;
          }

          _context14.next = 7;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.HOME_VISITS_DR_STATS.SUCCEEDED,
            data: homeVisitsDrStatsResponse.data
          });

        case 7:
          _context14.next = 16;
          break;

        case 9:
          if (!(homeVisitsDrStatsResponse.response.errorMessage === 'supplier is not found')) {
            _context14.next = 14;
            break;
          }

          _context14.next = 12;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.HOME_VISITS_DR_STATS.FAILED,
            errorMessage: _language.language === 'en' ? 'The doctor needs to switch on/off home visits at least once' : 'يجب على الدكتور تشغيل خدمة الزيارات المنزلية مرة على الأقل'
          });

        case 12:
          _context14.next = 16;
          break;

        case 14:
          _context14.next = 16;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.HOME_VISITS_DR_STATS.FAILED,
            errorMessage: _language.language === 'en' ? 'An error has occurred, please retry again' : '!حدث خطأ، يُرجى إعادة المحاولة'
          });

        case 16:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked12, this);
}

function loadHomeVisitsDrLiveStatus(payload) {
  var homeVisitsDrStats, homeVisitsDrStatsResponse;
  return _regenerator2.default.wrap(function loadHomeVisitsDrLiveStatus$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          homeVisitsDrStats = new _webUtils.API();
          _context15.next = 3;
          return homeVisitsDrStats.post(_webUtils.Urls.homeVisits.getDoctorsLiveStatus, payload.accKeys);

        case 3:
          homeVisitsDrStatsResponse = _context15.sent;

          if (!_webUtils.STATUS.isSuccess(homeVisitsDrStatsResponse.status)) {
            _context15.next = 9;
            break;
          }

          _context15.next = 7;
          return (0, _effects.put)({
            type: _entities2.ENTITIES.HOME_VISITS_DR_LIVE_STATUS.SUCCEEDED,
            data: homeVisitsDrStatsResponse.data
          });

        case 7:
          _context15.next = 11;
          break;

        case 9:
          _context15.next = 11;
          return (0, _effects.put)({ type: _entities2.ENTITIES.HOME_VISITS_DR_LIVE_STATUS.FAILED });

        case 11:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked13, this);
}

function entities() {
  return _regenerator2.default.wrap(function entities$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.ENTITIES.FETCH.LOADING, getEntitiesByEntityKeys);

        case 2:
          _context16.next = 4;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.BRANCHES.FETCH.LOADING, getBranchesByBranchKeys);

        case 4:
          _context16.next = 6;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.USERS.FETCH.LOADING, getUsersByKeys);

        case 6:
          _context16.next = 8;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.USERS.FETCH_BRANCHES.LOADING, getUsersBranches);

        case 8:
          _context16.next = 10;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.ENTITIES.EDIT.LOADING, upsertEntity);

        case 10:
          _context16.next = 12;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.BRANCHES.EDIT.LOADING, upsertBranch);

        case 12:
          _context16.next = 14;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.USERS.ADD.LOADING, upsertUser);

        case 14:
          _context16.next = 16;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.BRANCHES.FETCH_BRANCH_INSURANCES.LOAD, getBranchInsurances);

        case 16:
          _context16.next = 18;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.BRANCHES.SET_BRANCH_INSURANCES.LOAD, setBranchInsurances);

        case 18:
          _context16.next = 20;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.BRANCHES.SET_BRANCH_INSURANCES.SUCCESS, setBranchInsurancesSuccess);

        case 20:
          _context16.next = 22;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.BRANCHES.FETCH_BRANCH_INSURANCES.RESET, resetBranchInsurances);

        case 22:
          _context16.next = 24;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.HOME_VISITS_DR_STATS.LOADING, getHomeVisitsDrStats);

        case 24:
          _context16.next = 26;
          return (0, _effects.takeEvery)(_entities2.ENTITIES.HOME_VISITS_DR_LIVE_STATUS.LOADING, loadHomeVisitsDrLiveStatus);

        case 26:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked14, this);
}
module.exports = exports['default'];